module.exports = __webpack_public_path__ + "images/e9d8e7318ce5a873894262e0acc9204c-G-Adventures-Logo-2015-FINAL-Purple-HORIZONTAL.png";